/**
 * データエクスポート（売粗）画面機能定義ファイル
 *  ・概要
 *    データエクスポート画面で使用する定義ファイル
 *  ・更新履歴
 *    2022/07/04 新規作成 野口
 */
import { FieldChildrenProp } from '@/services/hexabase/types';
/* eslint-disable @typescript-eslint/camelcase */

// データレポート取得時に使用するソート条件
export const DefaultSortRequest = [{ 'id': 'expected_sales_date', 'order': 'asc'} ];

// 入力、選択時の情報から参照先となるマスタのidを決定するリスト
export const CatchInputMasterIdList: { [k: string]: string } = {
  'company_id': 'm_company',
  'manager_id': 'm_employee',
  'division': 'm_employee',
  'commodity_id': 'm_commodity',
  'service_type': 'm_service_type',
  'supplier_id': 'm_supplier'
};

// データエクスポート画面で表示するボタン情報
export const DataExportButtons: Array<{ [key: string]: string }> = [
  {
    style: 'font-size: 1.4rem;',
    color: 'primary',
    value: 'CSV出力',
    name: 'csvoutput_sjis',
    event: 'SJIS'
  },
  {
    style: 'font-size: 1.4rem;',
    color: 'btn-secondary',
    value: 'クリア',
    name: 'clear',
    event: 'clearButton'
  }
];

// eslint-disable-next-line @typescript-eslint/no-namespace
namespace optionalForm {
  // 予実抽出用フォーム
  export const DataReportOutputSellingSelectPlanAndActualForm = [
    {
      'display_id': 'plan_actual',
      component: 'SelectArea',
      props:{
        name: 'plan_actual',
        label: '予実',
        rules: 'selectRequired',
        selectData: {
          options:[
            {text: '予定', value:'予定'},
            {text: '実績', value:'実績'}
          ]
        },
        value: '予定'
      },
      col: 1,
      row: 1,
      sizeX: 3,
      sizeY: 1,
      show: true
    }
  ];

  // 出力条件用フォーム
  export const DataReportOutputSellingOrganizationConditionsForm: Array<FieldChildrenProp> = [
    {
      //** インタフェース利用のために必要なプロパティ、画面では未使用 **//
      'search': false,
      'show_list': false,
      'as_title': false,
      'status': false,
      'fieldIndex': 1,
      'title_order': 1,
      'full_text': false,
      'unique': false,
      'min_value': '',
      'max_value': '',
      // ****** //
      'field_id': '売上見込期間',
      'name': 'expected_sales_date',
      'dataType': 'datetime',
      // 売上期間
      'display_id': 'expected_sales_date',
      component: 'DatePickerRangeArea',
      props: {
        name: 'expected_sales_date',
        format: 'yyyy/MM/dd',
        // type: 'month',
        labelText: '売上見込期間',
        nameFrom: 'expected_sales_date',
        nameTo: 'expected_sales_date',
        valueFrom: '',
        valueTo: ''
      },
      col: 0,
      row: 0,
      sizeX: 2,
      sizeY: 1,
      'show': true,
    },
    {
      //** インタフェース利用のために必要なプロパティ、画面では未使用 **//
      'search': false,
      'show_list': false,
      'as_title': false,
      'status': false,
      'fieldIndex': 1,
      'title_order': 1,
      'full_text': false,
      'unique': false,
      'min_value': '',
      'max_value': '',
      // ****** //
      'field_id': 'ステータス',
      'name': 'status',
      'display_id': 'status',
      'dataType': 'select',
      'component': 'SelectArea',
      'props': {
        'name': 'status',
        'label': 'ステータス',
        'selectData': [],
        'isDisabled': false,
        'value': ''
      },
      'sizeX': 2,
      'sizeY': 1,
      'col': 2,
      'row': 0,
      'show': true,
    },
    {
      //** インタフェース利用のために必要なプロパティ、画面では未使用 **//
      'search': false,
      'show_list': false,
      'as_title': false,
      'status': false,
      'fieldIndex': 1,
      'title_order': 1,
      'full_text': false,
      'unique': false,
      'min_value': '',
      'max_value': '',
      // ****** //
      'field_id': '部・課',
      'name': 'division',
      'display_id': 'division',
      'dataType': 'select',
      'component': 'SelectArea',
      'props': {
        'name': 'division',
        'label': '部・課',
        'selectData': [],
        'isDisabled': false,
        'value': ''
      },
      'sizeX': 2,
      'sizeY': 1,
      'col': 0,
      'row': 1,
      'show': true,
    },
    {
      //** インタフェース利用のために必要なプロパティ、画面では未使用 **//
      'search': false,
      'show_list': false,
      'as_title': false,
      'status': false,
      'fieldIndex': 1,
      'title_order': 1,
      'full_text': false,
      'unique': false,
      'min_value': '',
      'max_value': '',
      // ****** //
      'dataType': 'text',
      'field_id': 'サービス種別',
      'name': 'サービス種別',
      'display_id': 'service_type',
      'component': 'MasterSelectSetControl',
      dblookup: 'm_service_type',
      props: {
        label: 'サービス種別',
        name: 'service_type',
        value: '',
        columns: [],
        body: [],
        dialogTitle: 'サービス種別選択',
        outPutData: [{ label: 'サービス種別', name: 'service_type', isDisabled: true, value: '' }]
      },
      'sizeX': 2,
      'sizeY': 1,
      'col': 2,
      'row': 1,
      'show': true,
    },
    // {
    //   //** インタフェース利用のために必要なプロパティ、画面では未使用 **//
    //   'search': false,
    //   'show_list': false,
    //   'as_title': false,
    //   'status': false,
    //   'fieldIndex': 1,
    //   'title_order': 1,
    //   'full_text': false,
    //   'unique': false,
    //   'min_value': '',
    //   'max_value': '',
    //   // ****** //
    //   'dataType': 'text',
    //   'field_id': '担当者',
    //   'name': 'manager_id',
    //   'display_id': 'manager_id',
    //   'component': 'MasterSelectSetControl',
    //   dblookup: 'm_employee',
    //   props: {
    //     label: '',
    //     name: 'manager_id',
    //     value: '',
    //     columns: [],
    //     body: [],
    //     dialogTitle: '担当者選択',
    //     outPutData: [{ label: '担当者', name: 'name', isDisabled: true, value: '' }]
    //   },
    //   'sizeX': 2,
    //   'sizeY': 1,
    //   'col': 0,
    //   'row': 2,
    //   'show': true,
    // },
    {
      //** インタフェース利用のために必要なプロパティ、画面では未使用 **//
      'search': false,
      'show_list': false,
      'as_title': false,
      'status': false,
      'fieldIndex': 1,
      'title_order': 1,
      'full_text': false,
      'unique': false,
      'min_value': '',
      'max_value': '',
      // ****** //
      'dataType': 'text',
      'field_id': '商材',
      'name': 'commodity_id',
      'display_id': 'commodity_id',
      'component': 'MasterSelectSetControl',
      dblookup: 'm_company',
      props: {
        label: '',
        name: 'commodity_id',
        value: '',
        columns: [],
        body: [],
        dialogTitle: '商材選択',
        outPutData: [{ label: '商材', name: 'commodity', isDisabled: true, value: '' }]
      },
      'sizeX': 2,
      'sizeY': 1,
      'col': 0,
      'row': 2,
      'show': true,
    },
    {
      //** インタフェース利用のために必要なプロパティ、画面では未使用 **//
      'search': false,
      'show_list': false,
      'as_title': false,
      'status': false,
      'fieldIndex': 1,
      'title_order': 1,
      'full_text': false,
      'unique': false,
      'min_value': '',
      'max_value': '',
      // ****** //
      'dataType': 'text',
      'field_id': '仕入れ先',
      'name': 'supplier_id',
      'display_id': 'supplier_id',
      'component': 'MasterSelectSetControl',
      dblookup: 'm_supplier',
      props: {
        label: '',
        name: 'supplier_id',
        value: '',
        columns: [],
        body: [],
        dialogTitle: '仕入れ先選択',
        outPutData: [{ label: '仕入れ先', name: 'supplier', isDisabled: true, value: '' }]
      },
      'sizeX': 2,
      'sizeY': 1,
      'col': 2,
      'row' : 2,
      'show': true
    }
  ];

  // 出力条件用フォーム
  export const DataReportOutputSellingRepresentativeConditionsForm: Array<FieldChildrenProp> = [
    {
      //** インタフェース利用のために必要なプロパティ、画面では未使用 **//
      'search': false,
      'show_list': false,
      'as_title': false,
      'status': false,
      'fieldIndex': 1,
      'title_order': 1,
      'full_text': false,
      'unique': false,
      'min_value': '',
      'max_value': '',
      // ****** //
      'field_id': '売上見込期間',
      'name': 'expected_sales_date',
      'dataType': 'datetime',
      // 売上期間
      'display_id': 'expected_sales_date',
      component: 'DatePickerRangeArea',
      props: {
        name: 'expected_sales_date',
        format: 'yyyy/MM/dd',
        // type: 'month',
        labelText: '売上見込期間',
        nameFrom: 'expected_sales_date',
        nameTo: 'expected_sales_date',
        valueFrom: '',
        valueTo: ''
      },
      col: 0,
      row: 0,
      sizeX: 2,
      sizeY: 1,
      'show': true,
    },
    {
      //** インタフェース利用のために必要なプロパティ、画面では未使用 **//
      'search': false,
      'show_list': false,
      'as_title': false,
      'status': false,
      'fieldIndex': 1,
      'title_order': 1,
      'full_text': false,
      'unique': false,
      'min_value': '',
      'max_value': '',
      // ****** //
      'field_id': 'ステータス',
      'name': 'status',
      'display_id': 'status',
      'dataType': 'select',
      'component': 'SelectArea',
      'props': {
        'name': 'status',
        'label': 'ステータス',
        'selectData': [],
        'isDisabled': false,
        'value': ''
      },
      'sizeX': 2,
      'sizeY': 1,
      'col': 2,
      'row': 0,
      'show': true,
    },
    {
      //** インタフェース利用のために必要なプロパティ、画面では未使用 **//
      'search': false,
      'show_list': false,
      'as_title': false,
      'status': false,
      'fieldIndex': 1,
      'title_order': 1,
      'full_text': false,
      'unique': false,
      'min_value': '',
      'max_value': '',
      // ****** //
      'field_id': '部・課',
      'name': 'division',
      'display_id': 'division',
      'dataType': 'select',
      'component': 'SelectArea',
      'props': {
        'name': 'division',
        'label': '部・課',
        'selectData': [],
        'isDisabled': false,
        'value': ''
      },
      'sizeX': 2,
      'sizeY': 1,
      'col': 0,
      'row': 1,
      'show': true,
    },
    {
      //** インタフェース利用のために必要なプロパティ、画面では未使用 **//
      'search': false,
      'show_list': false,
      'as_title': false,
      'status': false,
      'fieldIndex': 1,
      'title_order': 1,
      'full_text': false,
      'unique': false,
      'min_value': '',
      'max_value': '',
      // ****** //
      'dataType': 'text',
      'field_id': 'サービス種別',
      'name': 'サービス種別',
      'display_id': 'service_type',
      'component': 'MasterSelectSetControl',
      dblookup: 'm_service_type',
      props: {
        label: 'サービス種別',
        name: 'service_type',
        value: '',
        columns: [],
        body: [],
        dialogTitle: 'サービス種別選択',
        outPutData: [{ label: 'サービス種別', name: 'service_type', isDisabled: true, value: '' }]
      },
      'sizeX': 2,
      'sizeY': 1,
      'col': 2,
      'row': 1,
      'show': true,
    },
    {
      //** インタフェース利用のために必要なプロパティ、画面では未使用 **//
      'search': false,
      'show_list': false,
      'as_title': false,
      'status': false,
      'fieldIndex': 1,
      'title_order': 1,
      'full_text': false,
      'unique': false,
      'min_value': '',
      'max_value': '',
      // ****** //
      'dataType': 'text',
      'field_id': '担当者',
      'name': 'manager_id',
      'display_id': 'manager_id',
      'component': 'MasterSelectSetControl',
      dblookup: 'm_employee',
      props: {
        label: '',
        name: 'manager_id',
        value: '',
        columns: [],
        body: [],
        dialogTitle: '担当者選択',
        outPutData: [{ label: '担当者', name: 'name', isDisabled: true, value: '' }]
      },
      'sizeX': 2,
      'sizeY': 1,
      'col': 0,
      'row': 2,
      'show': true,
    },
    {
      //** インタフェース利用のために必要なプロパティ、画面では未使用 **//
      'search': false,
      'show_list': false,
      'as_title': false,
      'status': false,
      'fieldIndex': 1,
      'title_order': 1,
      'full_text': false,
      'unique': false,
      'min_value': '',
      'max_value': '',
      // ****** //
      'dataType': 'text',
      'field_id': '商材',
      'name': 'commodity_id',
      'display_id': 'commodity_id',
      'component': 'MasterSelectSetControl',
      dblookup: 'm_company',
      props: {
        label: '',
        name: 'commodity_id',
        value: '',
        columns: [],
        body: [],
        dialogTitle: '商材選択',
        outPutData: [{ label: '商材', name: 'commodity', isDisabled: true, value: '' }]
      },
      'sizeX': 2,
      'sizeY': 1,
      'col': 2,
      'row': 2,
      'show': true,
    },
    {
      //** インタフェース利用のために必要なプロパティ、画面では未使用 **//
      'search': false,
      'show_list': false,
      'as_title': false,
      'status': false,
      'fieldIndex': 1,
      'title_order': 1,
      'full_text': false,
      'unique': false,
      'min_value': '',
      'max_value': '',
      // ****** //
      'dataType': 'text',
      'field_id': '仕入れ先',
      'name': 'supplier_id',
      'display_id': 'supplier_id',
      'component': 'MasterSelectSetControl',
      dblookup: 'm_supplier',
      props: {
        label: '',
        name: 'supplier_id',
        value: '',
        columns: [],
        body: [],
        dialogTitle: '仕入れ先選択',
        outPutData: [{ label: '仕入れ先', name: 'supplier', isDisabled: true, value: '' }]
      },
      'sizeX': 2,
      'sizeY': 1,
      'col': 0,
      'row' : 3,
      'show': true
    }
  ];

  export const PlanChangeOptions = [
    {
      display_id: 'expected_sales_date',
      props: {
        name: 'expected_sales_date',
        labelText: '売上見込期間',
        format: 'yyyy/MM/dd',
        nameFrom: 'expected_sales_date',
        nameTo: 'expected_sales_date',
      }
    }
  ];
  export const ActualChangeOptions = [
    {
      display_id: 'expected_sales_date',
      props: {
        name: 'project_completion_date',
        labelText: '案件完了期間',
        format: 'yyyy/MM/dd',
        nameFrom: 'project_completion_date',
        nameTo: 'project_completion_date',
      }
    }
  ];
}
export const DataReportOutputSellingSelectPlanAndActualForm =
  optionalForm.DataReportOutputSellingSelectPlanAndActualForm;
export const DataReportOutputSellingOrganizationConditionsForm = optionalForm.DataReportOutputSellingOrganizationConditionsForm;
export const DataReportOutputSellingRepresentativeConditionsForm = optionalForm.DataReportOutputSellingRepresentativeConditionsForm;
export const PlanAndActualChangeForm:any = {
  '予定': optionalForm.PlanChangeOptions,
  '実績': optionalForm.ActualChangeOptions
};
/* eslint-enable */

